import { render, staticRenderFns } from "./distanceLearningPage.vue?vue&type=template&id=298def8a&scoped=true"
import script from "./distanceLearningPage.vue?vue&type=script&lang=ts"
export * from "./distanceLearningPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298def8a",
  null
  
)

export default component.exports